// extracted by mini-css-extract-plugin
module.exports = {"container":"CartItemList_container__36GBv","sectionTitle":"CartItemList_sectionTitle__2T2aa"};